import React from 'react';
import { connect } from "react-redux";

import {
  setMasonryJobSiteTestTestsCarriedOutBy,
  setMasonryJobSiteTestTestsSupervisedBy,
  setMasonryJobSiteTestDiameterOfHammerDrillBits,
  setMasonryJobSiteTestDrillingDepth,
  setMasonryJobSiteTestEmbedmentDepth,
  setMasonryJobSiteTestRefTestRing,
  setMasonryJobSiteTestInstallationProcessAccordingTo
} from '@reducers/selectors/material/actions';
import { APP_TEXTS } from '../../../../../../../../texts/texts';
import { unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

// eslint-disable-next-line react/prefer-stateless-function
class ResultsTable extends React.Component {

  render() {
    return (
      <div className="ml-2 mr-2">
        <label htmlFor="tests-carried-out-by" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.TESTS_CARRIED_OUT_BY_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="tests-carried-out-by"
                 value={this.props.testsCarriedOutBy}
                 onChange={({ target }) => this.props.setTestsCarriedOutBy(target.value)}
          />
        </label>

        <label htmlFor="tests-supervised-by" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.SUPERVISOR_TESTS_LABEL.Content}</span>
          <input className="form-control col-5" type="text" id="tests-supervised-by"
                 value={this.props.testsSupervisedBy}
                 onChange={({ target }) => this.props.setTestsSupervisedBy(target.value)}
          />
        </label>

        <label htmlFor="diameter-of-hammer-drill-bits" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.DIAMETER_HAMMER_LABEL.Content}</span>
          <input className="form-control col-5" type="number" lang="fr" id="diameter-of-hammer-drill-bits"
                value={unitTransform(this.props.diameterOfHammerDrillBits || 0).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                onChange={({ target }) => 
                  this.props.setDiameterOfHammerDrillBits(
                    unitTransform(Math.floor(target.value * 100) / 100 || 0).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                  )
                }
          />
        </label>

        <label htmlFor="drilling-depth" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.DRILLING_DEPTH_LABEL.Content}</span>
          <input className="form-control col-5" type="number" lang="fr" id="drilling-depth"
                value={unitTransform(this.props.drillingDepth || 0).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                onChange={({ target }) => 
                  this.props.setDrillingDepth(
                    unitTransform(Math.floor(target.value * 100) / 100 || 0).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                  )
                }
          />
        </label>

        <label htmlFor="embedment-depth" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.EMBEDMENT_DEPTH_LABEL.Content}</span>
          <input className="form-control col-5" type="number" lang="fr" id="embedment-depth"
                value={unitTransform(this.props.embedmentDepth || 0).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
                onChange={({ target }) => 
                  this.props.setEmbedmentDepth(
                    unitTransform(Math.floor(target.value * 100) / 100 || 0).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
                  )
                }
          />
        </label>

        <label htmlFor="ref-test-ring" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.REF_TEST_RING.Content}</span>
          <input className="form-control col-5" type="text" id="ref-test-ring"
                 value={this.props.refTestRing}
                 onChange={({ target }) => this.props.setRefTestRing(target.value)}
          />
        </label>

        <label htmlFor="installation-process-according-to" className="d-flex justify-content-between align-items-center">
          <span>{APP_TEXTS.INSTALLATION_PROCESS_LABEL.Content}</span>
          <select className="form-control col-5" id="installation-process-according-to"
                  value={this.props.installationProcessAccordingTo}
                  onChange={({ target }) => this.props.setInstallationProcessAccordingTo(target.value)}
          >
            <option value="1">{APP_TEXTS.MANUFACTURER_INSTRUCTION_LABEL.Content}</option>
            <option value="2">{APP_TEXTS.OTHER_LABEL.Content}</option>
          </select>
        </label>
      </div>
    );
  }

}

const mapState = state => ({
  testsCarriedOutBy: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.testsCarriedOutBy,
  testsSupervisedBy: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.testsSupervisedBy,
  diameterOfHammerDrillBits: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.diameterOfHammerDrillBits,
  drillingDepth: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.drillingDepth,
  embedmentDepth: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.embedmentDepth,
  refTestRing: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.refTestRing,
  installationProcessAccordingTo: state.selectors.material[state.main.appType].masonry.jobSiteTest.execution.installationProcessAccordingTo,
  distanceUnit: state.main.units.distance
});

const mapDispatch = dispatch => ({
  setTestsCarriedOutBy: value => dispatch(setMasonryJobSiteTestTestsCarriedOutBy(value)),
  setTestsSupervisedBy: value => dispatch(setMasonryJobSiteTestTestsSupervisedBy(value)),
  setDiameterOfHammerDrillBits: value => dispatch(setMasonryJobSiteTestDiameterOfHammerDrillBits(value)),
  setDrillingDepth: value => dispatch(setMasonryJobSiteTestDrillingDepth(value)),
  setEmbedmentDepth: value => dispatch(setMasonryJobSiteTestEmbedmentDepth(value)),
  setRefTestRing: value => dispatch(setMasonryJobSiteTestRefTestRing(value)),
  setInstallationProcessAccordingTo: value => dispatch(setMasonryJobSiteTestInstallationProcessAccordingTo(value)),
});

export default connect(mapState, mapDispatch)(ResultsTable);



// WEBPACK FOOTER //
// ./src/views/Material/components/Masonry/components/JobSiteTest/components/ExecutionFields/index.js